import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";

import "./index.css";

import { Web3ContextProvider } from "./hooks/web3Context";
import { ProjectInfoProvider } from "./hooks/useProjectinfo";

import store from "./state";
import { RefreshContextProvider } from "./context/RefreshContext";
import { NftInfoProvider } from "./hooks/useNftInfo";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Web3ContextProvider>
        <RefreshContextProvider>
          <ProjectInfoProvider>
            <NftInfoProvider>
              <App/>
            </NftInfoProvider>
          </ProjectInfoProvider>
        </RefreshContextProvider>
      </Web3ContextProvider>
    </Provider>
  </React.StrictMode>
);
